import usePaginationWrapper from "../general/usePaginationWrapper";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestionsStart } from "../../redux/questions/reducer";
import {
  selectIsFetchingQuestions,
  selectQuestionsList,
} from "../../redux/questions/selectors";

const useQuestionsGet = ({ paperId }) => {
  const dispatch = useDispatch();
  const isFetchingQuestions = useSelector(selectIsFetchingQuestions);
  const questions = useSelector(selectQuestionsList);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const fetchQuestions = useCallback(() => {
    dispatch(
      fetchQuestionsStart({
        paperId,
        keyword: debouncedSearchText,
        size: limit,
        page: (page - 1),
      })
    );
  }, [dispatch, paperId, debouncedSearchText, page, limit]);

  useEffect(() => {
    if (paperId) {
      fetchQuestions();
    }
  }, [fetchQuestions, paperId, fetch]);

  useEffect(() => {
    if (questions) {
      setPageable({
        total_elements: questions?.count,
        total_pages: questions?.pages,
        number_of_elements: questions?.items?.length,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, setPageable]);

  return {
    loadingQuestions: isFetchingQuestions,
    questions,
    setOffset,
    setLimit,
    limit,
    offset,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    setSearchText,
    refetch,
  };
};

export default useQuestionsGet;
